import React from 'react';
import DynamicLayout from '../components/DynamicLayout';
import { motion } from 'framer-motion';

const FAQ = () => {
  const faqs = [
    {
      question: "What is Saturnalia and what can I do here?",
      answer: "Saturnalia is a hub for self-serve esoteric tools and study resources. You can generate birth charts, track retrogrades, pull tarot and rune guidance, explore numerology, and dive into full learning paths inside the Saturn Academy."
    },
    {
      question: "Do I need an account to use the tools?",
      answer: "Most tools are instantly available without logging in. Creating an account lets you unlock member-only lessons, save progress, edit your profile, access messaging, and keep preferences synced across devices."
    },
    {
      question: "What’s included in the Academy and how do I access it?",
      answer: "The Academy hosts structured paths for Astrology, Tarot, Runes, Numerology, and upcoming Kabbalah content. Gold members can open the locked courses directly from the Academy page; everyone else sees previews and can upgrade anytime."
    },
    {
      question: "How do I upgrade to Gold membership?",
      answer: "Head to the Join University page from the Academy or Settings links. Upgrading to Gold removes course locks, grants full access to lessons, and ensures future premium content drops straight into your dashboard."
    },
    {
      question: "How can I edit or delete my profile?",
      answer: "Visit /profile to view your public profile, /profile-edit to update your bio, location, and interests, and /account for credential changes. There’s also a delete account flow under Account Settings → Delete Account if you ever need it."
    },
    {
      question: "How do I reset my password or recover my account?",
      answer: "Use the Forgot Password link on the login screens. We send a secure reset email through Firebase Auth so you can set a new password even if you can’t access the app."
    },
    {
      question: "Are the tools mobile-friendly?",
      answer: "Yes. The platform auto-detects mobile browsers and serves dedicated mobile layouts for every major view, so tarot spreads, randomizers, and account settings feel native on phones and tablets."
    },
    {
      question: "What data do you store and is it private?",
      answer: "We store only the basics in Firebase: your login credentials, optional profile details, and learning progress. All authenticated pages sit behind private routes, and nothing is shared publicly unless you explicitly post it."
    },
    {
      question: "Where can I ask questions or report an issue?",
      answer: "Use the contact page for general questions, or send an in-app message through the Messages section once you’re logged in. We monitor both and respond as fast as possible."
    }
  ];

  return (
    <DynamicLayout>
      <motion.div
        className="faq-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <section className="faq-content">
          <header className="faq-header">
            <p className="faq-tag">FAQ</p>
            <h1>Frequently Asked Questions</h1>
            <p className="faq-subtitle">
              Everything you need to know about Saturnalia’s tools, memberships, and account features.
            </p>
          </header>

          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <motion.article
                key={faq.question}
                className="faq-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </motion.article>
            ))}
          </div>

          <motion.div
            className="faq-cta"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
          >
            <h3>Still have questions?</h3>
            <p>Reach out anytime—our inbox at Saturnalia is always open.</p>
            <a href="/contact" className="faq-button">
              Get in Touch
            </a>
          </motion.div>
        </section>
      </motion.div>
    </DynamicLayout>
  );
};

export default FAQ;
